import {MDCSwitch} from '@material/switch';
import {MDCDialog} from '@material/dialog';

export class IframePopup{

    constructor(appManager){
        this.appManager = appManager
        this.currentContentURI

        this.initialise()
    }

    initialise(){
        this.iframePopup = new MDCDialog(document.getElementById('iframePopup'))
        this.iframeElement = document.getElementById('iframeElement')
        //this.iframePopupTitle = document.getElementById('imagePopupTitle')
        //this.imgPopup = document.getElementById('imgPopup')
        this.iframeFullscreen = document.getElementById('fullscreen-btn-iframe')
        this.iframeClose = document.getElementById('close-btn-iframe')
        this.iframePopup.scrimClickAction=''
        this.iframePopup.listen('MDCDialog:opened',()=> this.iframePopup.scrimClickAction='close')
        this.iframePopup.listen('MDCDialog:closed',()=> this.iframePopup.scrimClickAction='')

        this.iframeFullscreen.onclick = () => window.open(this.currentContentURI,'Image','width=largeImage.stylewidth,height=largeImage.style.height,resizable=1');
        this.iframeClose.onclick = () => this.iframePopup.close()
    }

    loadIframe(uri){
        //if(title != null)this.imagePopupTitle.innerHTML = title
        //else this.imagePopupTitle.innerHTML = ""

        this.currentContentURI = uri
        this.iframeElement.src = uri
        this.openIframePopup()
    }
    openIframePopup(){
        this.iframePopup.scrimClickAction=''
        this.iframePopup.open()
    }
    closeImagePopup(){
        
    }
}